module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6DImE"))).then(() => module.bundle.root('d0iPb'));